import styles from "../styles/Footer.module.css"

export default function Footer() {
    return (
        <div className={styles.footerContainer}>
            <h2 className={styles.footerTitle}>Parmarth Sadhna Charitable Trust (Regd.)</h2>
            <div className={styles.copyright}>
                <p>Copyright ©<span className="year">2025</span></p>
            </div>
        </div>
    )
}